package br.com.texeratx.boardgametimeapp.domain.usecases.expansions

import br.com.texeratx.boardgametimeapp.data.model.expansion.CreateExpansionRequest
import br.com.texeratx.boardgametimeapp.data.repository.ExpansionRepository

class CreateExpansionUseCase(
    private val repository: ExpansionRepository
) {
    suspend operator fun invoke(request: CreateExpansionRequest) =
        repository.createExpansion(request)
}
